<template>
  <div class="flex gap-2">
    <ui-input
      ref="input"
      class="min-w-0 flex-1"
      :model-value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="(event) => handleInput(event)"
      @click="() => updateCursorPosition()"
      @keyup="() => updateCursorPosition()"
    />
    <ui-dropdown-menu>
      <ui-dropdown-menu-trigger as-child>
        <ui-button :disabled="disabled">
          <plus-icon />
          {{ tr('Macros') }}
        </ui-button>
      </ui-dropdown-menu-trigger>
      <ui-dropdown-menu-content align="end" class="max-h-80 overflow-y-auto">
        <template v-for="(item, index) in templateParts">
          <ui-dropdown-menu-label v-if="item.title" :key="'title-' + index">
            {{ tr(item.title) }}
          </ui-dropdown-menu-label>
          <ui-dropdown-menu-item v-else :key="'item-' + index" @select="() => appendToInput(item)">
            {{ tr(item.label) }}
          </ui-dropdown-menu-item>
        </template>
      </ui-dropdown-menu-content>
    </ui-dropdown-menu>
  </div>
</template>

<script>
import { Plus } from '@lucide/vue';

/** Text input with a "Macros" menu that inserts a macro at the cursor. */
export default {
  name: 'TemplateableInput',
  components: {
    PlusIcon: Plus,
  },
  props: {
    modelValue: {
      type: String,
      required: true,
      default: '',
    },
    templateParts: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: [ 'update:modelValue' ],
  data: () => ({
    cursorPosition: 0,
  }),
  mounted() {
    this.updateCursorPosition();
  },
  methods: {
    handleInput(event) {
      this.updateCursorPosition();
      this.$emit('update:modelValue', event.target.value);
    },

    inputElement() {
      return this.$refs.input?.$el ?? null;
    },
    updateCursorPosition() {
      if (this.inputElement()) {
        this.cursorPosition = this.inputElement().selectionStart || 0;
      }
    },

    appendToInput(item) {
      if (item.value) {
        const value = item.value.trim();
        const input = this.inputElement();

        const cursorPos = this.cursorPosition;

        const before = this.modelValue.substring(0, cursorPos);
        const after = this.modelValue.substring(cursorPos);

        const leftChar = cursorPos > 0 ? this.modelValue.charAt(cursorPos - 1) : '';
        const rightChar = this.modelValue.charAt(cursorPos);

        let insertValue = value;
        if (leftChar !== ' ' && leftChar !== '') {
          insertValue = ' ' + insertValue;
        }
        if (rightChar !== ' ' && rightChar !== '') {
          insertValue = insertValue + ' ';
        }

        const newPosition = cursorPos + insertValue.length;
        const newValue = before + insertValue + after;

        this.$emit('update:modelValue', newValue);

        // After the menu has closed and returned focus to its trigger.
        setTimeout(() => {
          input.focus();
          input.setSelectionRange(newPosition, newPosition);
          this.cursorPosition = newPosition;
        }, 0);
      }
    },
  },
};
</script>

